import Typography from '@mui/material/Typography';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React from 'react';
import useIsMobile from '../../hooks/useIsMobile';

const ProfileTable = ({ headersList, data }) => {
  const isMobile = useIsMobile();
  const headers = isMobile ? [[].concat(...headersList)] : headersList;

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      justifyContent={isMobile ? 'normal' : 'space-evenly'}
      flex={1}
      sx={{ mb: '40px' }}
    >
      {headers.map((headerList) => (
        data.map((profile) => (
          <Stack
            key={profile.id}
            spacing={2}
            sx={{ mb: 2, '&:last-child': { mb: 0 } }}
          >
            {headerList.map((header) => (
              <Typography sx={{ py: 0.5, whiteSpace: 'pre-line' }} variant="body2" key={`${header.label}: ${header.getValue(profile)}`}>
                <Typography component="span" variant="h6">{header.label}</Typography>
                {' '}{header.getValue(profile)}
              </Typography>
            ))}
          </Stack>
        ))
      ))}
    </Stack>
  );
};

ProfileTable.propTypes = {
  headersList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    getValue: PropTypes.func,
  }))).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default ProfileTable;
